document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.wp-block-wdg-masthead-audience-buttons__mobile' ).forEach( ( dropdown ) => {
		const toggle = dropdown.querySelector( '.audience-dropdown__toggle' );
		const menu = dropdown.querySelector( '.audience-dropdown__menu' );

		if ( ! toggle || ! menu ) return;

		// Toggle menu open/close
		toggle.addEventListener( 'click', ( event ) => {
			event.stopPropagation();
			const expanded = toggle.getAttribute( 'aria-expanded' ) === 'true';
			toggle.setAttribute( 'aria-expanded', String( ! expanded ) );
			menu.hidden = expanded;
		} );

		// Close when clicking outside
		const handleOutsideClick = ( event ) => {
			if ( ! dropdown.contains( event.target ) ) {
				toggle.setAttribute( 'aria-expanded', 'false' );
				menu.hidden = true;
				document.removeEventListener( 'click', handleOutsideClick );
			}
		};

		// Open listener only when dropdown is expanded
		toggle.addEventListener( 'click', () => {
			if ( toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
				document.addEventListener( 'click', handleOutsideClick );
			}
		} );

		// Optional: close when pressing Escape
		dropdown.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Escape' ) {
				toggle.setAttribute( 'aria-expanded', 'false' );
				menu.hidden = true;
				toggle.focus();
			}
		} );
	} );
} );
